export enum FrequencyUnit {
    MONTHLY = 'monthly',
    YEARLY = 'yearly'
}
